import { setError } from "../../slices/errorSlice";
import type { AppDispatch } from "../../store";
import { normalizeError } from "../../utils/error-handling";

export const handleLoginError = async (error: unknown, dispatch: AppDispatch) => {
	if (error instanceof Error) {
		if (error.message === "BankIdTimeout") {
			dispatch(setError(normalizeError(error)));
			return;
		}

		setError(error);
		return;
	}

	if (error instanceof Response) {
		const res = await error.json();

		if (res.errorCode === "failedAuthSignStatus") {
			dispatch(setError(normalizeError(res)));
			return;
		}
	}

	throw error;
};
